import React from 'react';
import { RoleListTemplate } from 'themes/modules/role/pages';
import { setCurrentView } from 'core/utils';
import { RoleViewStore } from 'modules/role/stores';

@setCurrentView(rootStore => new RoleViewStore(rootStore), 'roleViewStore')
class RoleList extends React.Component {
	constructor(props) {
		super(props);
		const { roleViewStore } = this.props;
		roleViewStore.setSearchVisible();
	}

	render() {
		return <RoleListTemplate {...this.props} viewStore={this.props.roleViewStore} />;
	}
}

export default RoleList;
